export default "__VITE_ASSET__BscE_WVA__"